import { createContext } from '@lyearn/core/utils/context';
import useSetDialogs from '@/components/EditorBuilder/Settings/hooks/useSetDialogs';
import { ArticleContentType } from '@/types/schema';

import useArticleActions from '../hooks/useArticleActions';

const ARTICLE_CONTEXT_NAME = 'Article';

interface ArticleContext {
  article: ArticleContentType;
  isPreviewing?: boolean;
  articleContent: ReturnType<typeof useArticleActions>['articleContent'];
  onAction: ReturnType<typeof useArticleActions>['onAction'];
  importDialogOpen?: boolean;
  previewRootBlockId?: string;
  setDialog?: ReturnType<typeof useSetDialogs>['setDialog'];
  activeDialog?: ReturnType<typeof useSetDialogs>['activeDialog'];
  isDetailsPage?: boolean;
  journeySessionId?: string | null;
  hideAccessories?: boolean;
  pauseAvtivity?: boolean;
}

export const [ArticleContextProvider, useArticle] =
  createContext<ArticleContext>(ARTICLE_CONTEXT_NAME);
